import { call, put, select } from 'redux-saga/effects';

import { goToItemsService } from './router';
import { createItemRequest, deleteItemRequest, updateItemRequest } from '../requests';
import { pathSelector } from '../../../selectors';
import { createItem, deleteItem, updateItem } from '../../../actions';

export function* createItemService(data) {
  yield put(createItem(data));

  const { success } = yield call(createItemRequest, data);

  if (success) {
    yield call(goToItemsService);
  }
}

export function* updateItemService(id, data) {
  yield put(updateItem(id, data));
  yield call(updateItemRequest, id, data);
}

export function* updateCurrentItemService(data) {
  const { itemId } = yield select(pathSelector);

  yield call(updateItemService, itemId, data);
}

export function* deleteItemService(id) {
  const { itemId } = yield select(pathSelector);

  if (id === itemId) {
    yield call(goToItemsService);
  }

  yield put(deleteItem(id));
  yield call(deleteItemRequest, id);
}

export function* deleteCurrentItemService() {
  const { itemId } = yield select(pathSelector);

  yield call(deleteItemService, itemId);
}
